import React from "react";
import ReactDOM from "react-dom/client";
// Design tokens must load BEFORE any feature CSS so :root vars are defined.
import "./styles/tokens.css";
import "./styles/main.css";
import App from "./App";

// Make sure your HTML has <div id="root"></div>
const container = document.getElementById("root");
if (!container) throw new Error("No root element found");

const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
